import { useEffect, useState } from 'preact/hooks';
import { api } from '../api';
import { buildDashboardUrl, buildLoginUrl, isAuthenticated, setAuthenticationState } from '../state';

export default function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const hasUrlAuthToken = buildLoginUrl().includes('authToken=');

    const handleSubmit = async (e: Event) => {
        e.preventDefault();
        setErrorMessage('');
        setLoading(true);

        try {
            await api('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
                redirectOnUnauthorized: false,
                displayErrorModal: false
            });
            
            setAuthenticationState(true);
            window.location.href = buildDashboardUrl('/dashboard/');
        } catch (error) {
            setErrorMessage(
                error instanceof Error ? error.message : 'Impossibile effettuare il login.'
            );
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isAuthenticated.value === true) {
            window.location.href = buildDashboardUrl('/dashboard/');
        }
    }, [isAuthenticated.value]);

    if (isAuthenticated.value === true) {
        return null;
    }

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h1 className="login-title">
                        <span className="icon">🐟</span>
                       Branzino Analytics
                    </h1>
                    <p className="login-subtitle">Accedi al tuo account</p>
                </div>

                {hasUrlAuthToken && (
                    <div className="login-error" role="status">
                        Link di accesso rilevato. Se non funziona, usa username e password.
                    </div>
                )}
                
                <form onSubmit={handleSubmit} className="login-form" action="/api/login" method="POST">
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input
                            id="username"
                            type="text"
                            name="username"
                            value={username}
                            onInput={(e) => setUsername((e.target as HTMLInputElement).value)}
                            placeholder="Inserisci username"
                            autocomplete="username"
                            required
                            autoFocus
                        />
                    </div>
                    
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            id="password"
                            type="password"
                            name="password"
                            autocomplete="current-password"
                            value={password}
                            onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
                            placeholder="Inserisci password"
                            required
                        />
                    </div>

                    {errorMessage && (
                        <div className="login-error" role="alert">
                            {errorMessage}
                        </div>
                    )}
                    
                    <button 
                        type="submit" 
                        className="login-button"
                        disabled={loading}
                    >
                        {loading ? 'Accesso in corso...' : 'Accedi'}
                    </button>
                </form>
            </div>
        </div>
    );
}
